import {
  GamoraConstructorType,
  GamoraFoundationNode,
  GamoraFoundationNodeArgs,
} from '@ver.id/libs.internal.gamora';
import {
  HoruzProtocolChulakNode,
  HoruzProtocolChulakNodeArgs,
} from './chulak/chulak.js';
import { IHoruz } from '../horuz.js';

/**
 * Children map
 * @public
 */
export interface HoruzProtocolNodeChildrenMap<TRoot extends IHoruz> {
  chulak: GamoraConstructorType<HoruzProtocolChulakNode<TRoot>>;
}

/**
 * Args
 * @public
 */
export interface HoruzProtocolNodeArgs<
  TRoot extends IHoruz,
> extends GamoraFoundationNodeArgs<HoruzProtocolNodeChildrenMap<TRoot>> {
  chulak?: HoruzProtocolChulakNodeArgs<TRoot>;
}

/**
 * HoruzProtocolNode
 * @public
 */
export class HoruzProtocolNode<
  TRoot extends IHoruz,
> extends GamoraFoundationNode<HoruzProtocolNodeChildrenMap<TRoot>, TRoot> {
  constructor(args: HoruzProtocolNodeArgs<TRoot>) {
    super({
      ...args,
      childMap: {
        chulak: [HoruzProtocolChulakNode, args.chulak ?? {}],
      },
    });
  }
}
